export function createBuilderMethods(api) {
    return {
        async getBuilderState(campaignId) {
            const {data} = await api.gamemasterCampaignsBuilderStateRetrieve(campaignId);
            return data;
        },

        /**
         * @param {string} campaignId
         * @param {{step?: string, markComplete?: string}} state - `markComplete` flags a step
         *   done in `builder_meta`; it does not have to equal `step`.
         */
        async setBuilderState(campaignId, {step, markComplete} = {}) {
            const {data} = await api.gamemasterCampaignsBuilderStatePartialUpdate(campaignId, {
                step,
                mark_complete: markComplete,
            });
            return data;
        },

        async setStartPosition(campaignId, positionId) {
            const {data} = await api.gamemasterCampaignsStartPositionCreate(campaignId, {position_id: positionId});
            return data;
        },

        /**
         * @param {string} campaignId
         * @param {{sub_location_id: string, grid_x: number, grid_y: number, grid_z?: number, labels?: string[]}} position
         */
        async createPosition(campaignId, position) {
            const {data} = await api.gamemasterCampaignsPositionsCreate(campaignId, position);
            return data;
        },
    };
}
